import React from 'react'

import Svg from './svg'


export default function DoneIcon({width, height, color, ...props}) {
    color = getComputedStyle(document.documentElement)
        .getPropertyValue(color || '--on-content') || color

    return <Svg width={width || '16px'} height={height || '16px'} viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g id="done" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path d="M13,52 L27,42 L41,61 L81,9 L93,24 L42,91 Z" id="Path" fill={color || "white"}></path>
        </g>
    </Svg>
}
